import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import { IPagination } from '../IPagination';
import { fetchStandbyPeriods, fetchStandbyPeriodsInBatch } from './index';
import { IFetchStandbyPeriodsInBatchRequestParams, IFetchStandbyPeriodsRequestParams, IStandbyPeriod } from './interface';

export const useStandbyPeriodsInBatchListQuery = (query: IFetchStandbyPeriodsInBatchRequestParams, options = {}) => {
    return useQuery<IStandbyPeriod[], Error>({
        queryKey: [QueryKey.STANDBY_PERIODS, query],
        queryFn: ({ signal }) => fetchStandbyPeriodsInBatch(query, signal),
        ...options,
    });
};

export const useStandbyPeriodsListQuery = (query: IFetchStandbyPeriodsRequestParams, options = {}) => {
    return useQuery<IPagination<IStandbyPeriod>, Error>({
        queryKey: [QueryKey.STANDBY_PERIODS, query],
        queryFn: ({ signal }) => fetchStandbyPeriods(query, signal),
        ...options,
    });
};
